export const taleTherapy = {
    'meta': {
        'title': 'Spotkanie z bajką terapeutyczną • Centrum Psychoterapii COLLIGO',
        'description': 'Oferta warsztatów psychoedukacyjnych dla dzieci w wieku od 5 do 10 lat „Spotkanie z bajką terapeutyczną” na podstawie książki Barbary Krzemińskiej i Faustyny Krzemińskiej „Zaczarowany Cyrk Pana Teodora”'
    },
    'availability': [
        'torun',
        'bydgoszcz'
    ],
    'url': {
        'address': '#cityIdUrl#/uslugi/warsztaty-spotkanie-z-bajka-terapeutyczna/torun/',
        'title': 'Spotkanie z bajką terapeutyczną #cityLocativeIn#',
        'name': 'Spotkanie z bajką terapeutyczną #cityLocativeIn#',
        'heading': 'Spotkanie z bajką terapeutyczną',
        'fullName': 'Spotkanie z bajką terapeutyczną'
    },
    'image': {
        'url': '/images/services/warsztaty-terapeutyczne-dla-dzieci.webp',
        'width': 840,
        'height': 321,
        'alt': 'Spotkanie z bajką terapeutyczną'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/open-graph/warsztaty-terapeutyczne-dla-dzieci.webp',
            'width': 840,
            'height': 321,
            'alt': 'Spotkanie z bajką terapeutyczną'
        }
    }
}